<template>
  <div>
    <!-- TODO: loading -->
    <h4 class="text-center">Pesquisar empresas</h4>

    <img
      src="@/assets/images/search.png"
      alt="search"
      class="d-none d-lg-block w-100 mb-5"
    />

    <div class="form-group row mb-1">
      <div class="col-lg-3 mb-1 mb-lg-0">
        <label>Id</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="company_filters.id"
        />
      </div>
      <div class="col-lg-9 mb-1 mb-lg-0">
        <label>Nome / Razão Social</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="company_filters.name"
        />
      </div>
    </div>

    <div class="form-group row mb-1">
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>CNPJ</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="company_filters.cnpj"
        />
      </div>
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>Telefone</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="company_filters.phone"
        />
        <!-- Todo -->
      </div>
    </div>

    <div class="form-group row mb-3">
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>Endereço</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="company_filters.address"
        />
      </div>
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>Estado</label>
        <Dropdown
          ref="state_dropdown"
          v-model="state_filters.short_name"
          :editable="true"
          :options="filtered_states"
          option-label="short_name"
          option-value="short_name"
          class="w-100"
          @change="onCompanyStateChange"
          @input="onCompanyStateInput"
        />
      </div>
    </div>

    <div
      class="
        d-flex
        flex-column flex-lg-row
        align-items-center
        Isjustify-content-start
        justify-content-lg-between
      "
    >
      <button class="btn btn-success mb-3 mb-lg-0" @click="onFilter">
        <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon>
        Filtrar
      </button>

      <button class="btn btn-secondary" @click="clearFilter">
        <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
        Resetar
      </button>
    </div>
  </div>
</template>

<script>
  import { onBeforeMount, onMounted, ref } from 'vue'
  import useCompanies from '@/modules/Company.js'
  import useAddresses from '@/modules/Address.js'
  import Dropdown from 'primevue/dropdown'

  export default {
    setup() {
      const loading = ref(true)
      const state_dropdown = ref(null)

      const { filtered_states, state_filters, listStates } = useAddresses()

      const { company_filters, listCompanies } = useCompanies()

      const clearFilter = () => {
        company_filters.value = {}
        state_filters.value.short_name = ''
        refreshList()
      }

      const onFilter = () => {
        refreshList()
      }

      const onCompanyStateChange = (event) => {
        if (event.value == null) {
          listStates()
        }

        company_filters.value.state = event.value
      }

      const onCompanyStateInput = (event) => {
        state_dropdown.value.show()

        console.log(event) //É obrigatório ter o event como parâmetro, mas ele não é necessário na função...

        company_filters.value.state = state_filters.value.short_name
      }

      const refreshList = () => {
        listCompanies(1, 10)
      }

      onBeforeMount(() => {
        clearFilter()
      })

      onMounted(() => {
        listStates().then(() => {
          loading.value = false
        })
      })

      return {
        company_filters,
        onCompanyStateChange,
        onCompanyStateInput,
        onFilter,
        state_filters,
        filtered_states,
        clearFilter,
        loading,
        state_dropdown,
      }
    },
    components: {
      Dropdown,
    },
  }
</script>
